//Componentes generales
import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Routes_gral from "../../utils/Routes_gral";
import UserInfo from "../../components/UserInfo/UserInfo";
import { getRealTimeServerURL } from "../../config/config";
import { getCuentasByUserId } from "../../api/user";
import { PROV } from "../../utils/roles";

//Estilos
import "./Navbar.css";

//Contexto para recuperar usuario que se esta utilizando
import authContext from "../../context/authentication/authContex";

//Imagenes
//import logoXertux from '../../Logos/LOGO PNG CMYK.png';
import logoXertux from "../../Logos/LOGO PNG CYMK.png";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCardClip, faGlobe } from "@fortawesome/free-solid-svg-icons";

//Permisos
import { VER_CONFIG_GLOBAL } from "../../utils/permisos";

/* 
  Componente encargado del encabezado general de la pagina.
    Donde section es el titulo de la sección (Ruta nav) en que esta posicionado el usuario.
*/
const StyledNavbar_top = ({ section }) => {
  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuario: user } = aContext;
  //State que determina si muestra o no el dialog de información del usuario.
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [cuentasUsuario, setCuentasUsuario] = useState([]);
  const [serverUL, setServerURL] = useState("");

  //Chequea si esta visible el dialog de información de usuario
  const checkEstadoVisibilidad = async () => {
    if (showUserInfo) {
      setShowUserInfo(false);
      setCuentasUsuario([]);
      return;
    }
    const isProv = user?.userType?.some(ut => ut.typeName === PROV);
    let cuentas = [];
    if (isProv && user?._id) {
      try {
        const resp = await getCuentasByUserId(user._id);
        cuentas = resp.data.data || [];
      } catch {
        cuentas = [];
      }
    }
    setCuentasUsuario(cuentas);
    setShowUserInfo(true);
  };

  useEffect(() => {
    const respServerUL = getRealTimeServerURL();
    setServerURL(respServerUL);
  }, []);

  return (
    <div className="">
      <div className="container-top-xx">
        <img
          src={logoXertux}
          className="container-left-top-img-xx"
          alt="Logo-Top-Nav"
        />
        <h2 className="label-screen-h2-xx" style={{ fontWeight: "bold" }}>
          {section}
        </h2>
        <div id="userInfo" className="previewCompanyImgContainer">
          <img
            className="previewCompanyImg"
            src={`${serverUL}/logos/logo_empresa.jpg?ts=${Date.now()}`}
            alt="Logo-Empresa"
          />
        </div>

        <div id="userInfo" className="navbar-item-icon-xx">
          {user.userType.some((item) =>
            VER_CONFIG_GLOBAL.includes(item.typeName)
          ) && (
            <NavLink
              className={`globalSettings`}
              to={Routes_gral.globalSettings}
            >
              <FontAwesomeIcon icon={faGlobe} />
            </NavLink>
          )}
          <FontAwesomeIcon
            icon={faIdCardClip}
            onClick={checkEstadoVisibilidad}
          />
        </div>
      </div>
      {showUserInfo && (
        <div id="idUserInfo" className="modal-xx">
          <UserInfo
            user={user}
            cuentas={cuentasUsuario}
            verCerrarSesion={true}
            mode={checkEstadoVisibilidad}
          />
        </div>
      )}
      <div className="infoProv" style={{ height: "60px" }}>
        <h2></h2>
        {user.nroCta ? (
          <h2>
            {user.nroCta} - {user.fullName}
          </h2>
        ) : (
          <h2>{user.fullName}</h2>
        )}
        <h2></h2>
      </div>
    </div>
  );
};
export default StyledNavbar_top;